import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import blogs from "../data/blogdata";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";

export default function AllBlogsPage() {
    const [searchQuery, setSearchQuery] = useState("");
  const blogsPerPage = 9;
  const [currentPage, SetCurrentPage] = useState(1);
//   const totalPages = Math.ceil(blogs.length / blogsPerPage);
  const [selectedCategory, setSelectedCategory] = useState("All");

   const categories = [
    "All",
    "General",
    "AI & Innovation",
    "Web Development",
    "Mobile Development",
    "Technology",
    "Quality Assurance"
  ];

  
  // ✅ Filter blogs by search and category
   const filteredBlogs = blogs.filter((blog) => {
    const matchesSearch = blog.title.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = selectedCategory === "All" || blog.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  // ✅ Sort blogs by date (latest first)when date format is yyyy-dd-mm
  // const sortedBlogs = [...filteredBlogs].sort(
  //   (a, b) => new Date(b.date) - new Date(a.date)
  // );
   // ✅ Sort blogs by date (latest first) when date format is dd-mm-yyyy
  const sortedBlogs = [...filteredBlogs].sort((a, b) => {
  const dateA = new Date(a.date.split("-").reverse().join("-"));
  const dateB = new Date(b.date.split("-").reverse().join("-"));
  return dateB - dateA; // latest first
  });

   // ✅ Pagination logic
  const totalPages = Math.ceil(sortedBlogs.length / blogsPerPage);
  const startIndex = (currentPage - 1) * blogsPerPage;
  const paginatedBlogs = sortedBlogs.slice(startIndex, startIndex + blogsPerPage);


  // Array of all page numbers
  const numOfButtons = [];
  for (let i = 1; i <= totalPages; i++) {
    numOfButtons.push(i);
  }

  const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);

  useEffect(() => {
    let tempNumberOfButtons = [...arrOfCurrButtons];
    const dotsInitial = "...";
    const dotsLeft = "... ";
    const dotsRight = " ...";

    if (numOfButtons.length < 6) {
      tempNumberOfButtons = numOfButtons;
    } else if (currentPage >= 1 && currentPage <= 3) {
      tempNumberOfButtons = [1, 2, 3, 4, dotsInitial, numOfButtons.length];
    } else if (currentPage === 4) {
      const sliced = numOfButtons.slice(0, 5);
      tempNumberOfButtons = [...sliced, dotsInitial, numOfButtons.length];
    } else if (currentPage > 4 && currentPage < numOfButtons.length - 2) {
      const sliced1 = numOfButtons.slice(currentPage - 2, currentPage);
      const sliced2 = numOfButtons.slice(currentPage, currentPage + 1);
      tempNumberOfButtons = [1, dotsLeft, ...sliced1, ...sliced2, dotsRight, numOfButtons.length];
    } else if (currentPage > numOfButtons.length - 3) {
      const sliced = numOfButtons.slice(numOfButtons.length - 4);
      tempNumberOfButtons = [1, dotsLeft, ...sliced];
    }

    if (currentPage === dotsInitial) {
      SetCurrentPage(arrOfCurrButtons[arrOfCurrButtons.length - 3] + 1);
    } else if (currentPage === dotsRight) {
      SetCurrentPage(arrOfCurrButtons[3] + 2);
    } else if (currentPage === dotsLeft) {
      SetCurrentPage(arrOfCurrButtons[3] - 2);
    }

    setArrOfCurrButtons(tempNumberOfButtons);
  }, [currentPage, totalPages]);

  const handlePrev = () => {
    if (currentPage > 1) 
      SetCurrentPage(currentPage - 1);
     window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNext = () => {
    if (currentPage < totalPages) SetCurrentPage(currentPage + 1);
     window.scrollTo({ top: 0, behavior: "smooth" });
  };

//   const startIndex = (currentPage - 1) * blogsPerPage;
//   const paginatedBlogs = blogs.slice(startIndex, startIndex + blogsPerPage);


  
  return (
    <div className="all-blogs-page">
       {/* ✅ Meta Tags for SEO */}
      <Helmet>
        <title>All Blog Articles | Pravisht Digital</title>
        <meta name="description" content="Explore insights and articles on AI, web development, mobile tech, QA, and more. Stay updated with Pravisht's latest blogs." />
        <meta name="keywords" content="Pravisht Blog, Technology Articles, AI Blogs, Web Development, QA Testing, Software Development Blogs" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Pravisht Digital" />
        <meta property="og:title" content="All Blog Articles | Pravisht Digital" />
        <meta property="og:description" content="Discover expert-written blogs on technology, innovation, and software development from the team at Pravisht." />
        <meta property="og:image" content="/default-blog-banner.jpg" />
        <meta property="og:url" content="https://www.pravisht.com/blogs" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className="breadcrumb">
        <a href="/" className="mx-1">Home </a>  &gt; <span className="mx-1"> Blog List</span>
      </div>
      <h1>All Articles</h1>
      {/* Search input */}
<div className="search-container">
  <input
    type="text"
    placeholder="Search blogs..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    className="search-input"
  />
</div>

{/* Category chips */}
<div className="category-filter">
  {categories.map((category) => (
    <button
      key={category}
      className={`category-chip ${selectedCategory === category ? "active" : ""}`}
      onClick={() => {
  setSelectedCategory(category);
  SetCurrentPage(1);
}}
    >
      {category}
    </button>
  ))}
</div>
    <div className="row blog-cards">
  {paginatedBlogs.length === 0 ? (
    <div className="no-results" style={{ textAlign: "center", width: "100%", padding: "40px", color: "#777" }}>
      <h3>No blogs found for the selected category</h3>
    </div>
  ) : (
    paginatedBlogs.map((blog) => (
      <div key={blog.id} className="post__card-2">
        <div className="post__card_-2">
          <div
            className="post__card__image-2"
            style={{ backgroundImage: `url(${blog.image})` }}
          />
          <div className="post__card_meta-2">
            <div className="post__card_cat">{blog.category}</div>
            <h4 className="post__card_title-2">{blog.title}</h4>
            <p className="post__card_alttitle-2">{blog.description}</p>
            <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}> 
              <p className="post__card_alttitle-2"><span style={{color:"#000", fontWeight:"500"}}>Posted On : </span>{blog.date}</p>
               <Link to={`/blog/${blog.id}`} className="readmore-btn">
                Read More<span> →</span>
              </Link>
            </div>
           
          </div>
        </div>
      </div>
    ))
  )}
</div>
  

      <div className="dt-pagination">
        <ul className="dt-pagination-ul">
          <li className={`dt-item ${currentPage === 1 ? "disabled" : ""}`}>
            <a className="dt-link" onClick={handlePrev}>
              Prev
            </a>
          </li>

          {arrOfCurrButtons.map((data, index) => {
            const isDisabled = typeof data === "string";
            return (
              <li
                key={index}
                className={`dt-item ${currentPage === data ? "active" : ""} ${
                  isDisabled ? "disabled" : ""
                }`}
              >
                <a
                  className="dt-link"
                  onClick={() => {
                    if (!isDisabled)
                       SetCurrentPage(data);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  style={{ cursor: isDisabled ? "default" : "pointer" }}
                >
                  {data}
                </a>
              </li>
            );
          })}

          <li className={`dt-item ${currentPage === totalPages ? "disabled" : ""}`}>
            <a className="dt-link" onClick={handleNext} >
              Next
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
